"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var designer_layout_row_model_1 = require("../../layout-models/designer-layout-row.model");
var layout_utils_1 = require("../layout-utils");
var form_card_model_1 = require("../../layout-models/form-models/form-card.model");
var form_designer_constants_1 = require("../../components/designer/form/form-designer.constants");
var FormCardElement = /** @class */ (function () {
    function FormCardElement(domInfo) {
        this.domInfo = domInfo;
    }
    FormCardElement.prototype.onClone = function (designerContext) {
        if (this.cardIsInLayout()) {
            var draggingElement_1 = this.domInfo.getElem();
            var cloned_1 = false;
            var animationIndex_1 = 0;
            var offsetTop_1 = 0;
            var offsetLeft_1 = 0;
            var getCoordinates_1 = function (mouseEvent) {
                offsetLeft_1 = mouseEvent.clientX - draggingElement_1.offsetLeft;
                offsetTop_1 = mouseEvent.clientY - draggingElement_1.offsetTop;
            };
            var animate_1 = function () {
                animationIndex_1 += 1;
            };
            var element_1 = document.querySelectorAll('.form-designer-card.gu-mirror .form-designer-toolbar')[0];
            draggingElement_1.onmousemove = function (mouseEvent) {
                if (designerContext.itemInTrash) {
                    draggingElement_1.classList.add('form-designer-card--trash');
                }
                else {
                    draggingElement_1.classList.remove('form-designer-card--trash');
                }
                if (!cloned_1) {
                    getCoordinates_1(mouseEvent);
                    cloned_1 = true;
                }
                if (animationIndex_1 <= 20) {
                    element_1.style.width = "calc(100% - " + (animationIndex_1 * 8).toString() + "px)";
                    element_1.style.height = (160 - (animationIndex_1 * 2)).toString() + 'px';
                    element_1.style.marginTop = (animationIndex_1 / 2).toString() + 'px';
                    if (offsetLeft_1 > 80) {
                        element_1.style.marginLeft = (animationIndex_1 * 4).toString() + 'px';
                        element_1.style.marginRight = (animationIndex_1 * 4).toString() + 'px';
                    }
                    animate_1();
                }
            };
        }
    };
    FormCardElement.prototype.onDrag = function (designerContext) {
        designerContext.showCardTrashBin = true;
    };
    FormCardElement.prototype.onDrop = function (designerContext) {
        var designerContentLayout = designerContext.layoutContent;
        if (this.cardInScrollElement()) {
            designerContext.cancelDragging('card-type-bag');
            var rowId_1 = this.domInfo.getSourceRowId();
            var rowIndex = designerContentLayout.layoutRows.findIndex(function (layoutRow) { return layoutRow.id === rowId_1; });
            var droppedElement = designerContext.scrollModels.pop();
            if (rowIndex >= 0) {
                designerContext.layoutCards.splice(rowIndex, 0, droppedElement);
            }
        }
        else if (this.cardDeleted()) {
            var layoutRowId_1 = this.domInfo.getElemAttribute('row_id');
            var cardId_1;
            var indexToDelete = designerContentLayout.layoutRows.findIndex(function (row) {
                if (row.id === layoutRowId_1) {
                    cardId_1 = row.cards[0].id;
                    return true;
                }
                return false;
            });
            if (indexToDelete >= 0) {
                designerContentLayout.layoutRows.splice(indexToDelete, 1);
                if (designerContentLayout.layoutRows.length === 0) {
                    designerContext.layoutCards = [];
                }
            }
            if (designerContext.isCardSettingsActive &&
                designerContext.formCardSettingsComponent.card.id === cardId_1) {
                designerContext.formCardSettingsComponent.close();
            }
        }
        else if (this.newCardDropped()) {
            var droppedItemIndex = designerContext.layoutCards.findIndex(function (card) { return !card.checkedInLayout; });
            if (droppedItemIndex >= 0) {
                designerContext.layoutCards[droppedItemIndex].checkedInLayout = true;
                var row = new designer_layout_row_model_1.DesignerLayoutRowModel();
                var card = new form_card_model_1.FormCardModel();
                card.columnCount = 12;
                row.id = layout_utils_1.LayoutUtils.uniqueId();
                card.id = layout_utils_1.LayoutUtils.uniqueId();
                row.addCard(card);
                designerContext.cardUpperRowModels.set(card.id, []);
                designerContext.layoutCards[droppedItemIndex].card = card;
                designerContext.layoutCards[droppedItemIndex].rowId = row.id;
                designerContentLayout.insertRowOnIndex(row, droppedItemIndex);
            }
        }
        else if (this.cardReOrdered()) {
            var rowId_2 = this.domInfo.getElemAttribute('row_id');
            var indexOfRowInDesigner = designerContext.layoutCards.findIndex(function (item) { return item.rowId === rowId_2; });
            var indexOfRowInLayout = designerContentLayout.layoutRows.findIndex(function (item) { return item.id === rowId_2; });
            var rowToSwap = designerContentLayout.layoutRows[indexOfRowInLayout];
            designerContentLayout.layoutRows[indexOfRowInLayout] =
                designerContentLayout.layoutRows[indexOfRowInDesigner];
            designerContentLayout.layoutRows[indexOfRowInDesigner] = rowToSwap;
        }
    };
    FormCardElement.prototype.onHover = function (designerContext) {
        if (this.cardInScrollTopElement()) {
            layout_utils_1.LayoutUtils.scrollUp(designerContext);
            return;
        }
        if (this.cardInScrollBottomElement()) {
            layout_utils_1.LayoutUtils.scrollDown(designerContext);
            return;
        }
        if (this.cardInTrash()) {
            this.domInfo.addClassToElem('form-designer-card--trash');
            designerContext.itemInTrash = true;
        }
        else {
            this.domInfo.removeClassFromElem('form-designer-card--trash');
            designerContext.itemInTrash = false;
        }
    };
    FormCardElement.prototype.cardInTrash = function () {
        return this.domInfo.containerIdEquals(form_designer_constants_1.FormDesignerConstants.CARD_TRASH_BIN);
    };
    FormCardElement.prototype.cardIsInLayout = function () {
        return !this.domInfo.elemIdEquals(form_designer_constants_1.FormDesignerConstants.NEW_CARD_ID);
    };
    FormCardElement.prototype.cardDeleted = function () {
        return (this.domInfo.sourceIdEquals(form_designer_constants_1.FormDesignerConstants.CARDS_CONTAINER) &&
            this.domInfo.containerIdEquals(form_designer_constants_1.FormDesignerConstants.CARD_TRASH_BIN));
    };
    FormCardElement.prototype.newCardDropped = function () {
        return (this.domInfo.elemIdEquals(form_designer_constants_1.FormDesignerConstants.NEW_CARD_ID) &&
            this.domInfo.containerIdEquals(form_designer_constants_1.FormDesignerConstants.CARDS_CONTAINER));
    };
    FormCardElement.prototype.cardReOrdered = function () {
        return (this.domInfo.sourceIdEquals(form_designer_constants_1.FormDesignerConstants.CARDS_CONTAINER) &&
            this.domInfo.containerIdEquals(form_designer_constants_1.FormDesignerConstants.CARDS_CONTAINER));
    };
    FormCardElement.prototype.cardInScrollTopElement = function () {
        return this.domInfo.containerIdEquals(form_designer_constants_1.FormDesignerConstants.CARD_SCROLLER_TOP_ELEMENT);
    };
    FormCardElement.prototype.cardInScrollBottomElement = function () {
        return this.domInfo.containerIdEquals(form_designer_constants_1.FormDesignerConstants.CARD_SCROLLER_BOTTOM_ELEMENT);
    };
    FormCardElement.prototype.cardInScrollElement = function () {
        return (this.cardInScrollTopElement() || this.cardInScrollBottomElement());
    };
    return FormCardElement;
}());
exports.FormCardElement = FormCardElement;
//# sourceMappingURL=form-card.element.js.map